import z from 'zod';
import { createAnalyticsSchema } from '../factory';
export var AnalyticsDataSchema = createAnalyticsSchema({
    path: z.string(),
    message: z.string(),
    type: z.string(),
    data: z.any(),
});
